import getFromCdn from '@anm/helpers/getFromCdn';
import { grayToBlackFilter, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ItemProps } from './types';

export const Arrow = styled.span`
  width: 11px;
  height: 20px;
  margin: 0 14px;
  background: url(${getFromCdn('images/dashboard/breadcrumb-arrow-thin.svg')})
    center / 6px 11px no-repeat;
  ${grayToBlackFilter};
`;

const lastItemStyles = css`
  pointer-events: none;
  &:after {
    height: 0;
  }
`;

export const BreadcrumbItem = styled.div<ItemProps>`
  font-size: 16px;
  position: relative;
  &:after {
    content: '';
    left: 0;
    height: 1px;
    width: 100%;
    bottom: -2px;
    position: absolute;
    background: #292a2b;
  }
  ${({ isLast }) => isLast && lastItemStyles}
`;

export const ItemWrapper = styled.div<ItemProps>`
  display: flex;
  a {
    color: #292a2b;
  }
  ${({ isLast }) => isLast && lastItemStyles}
`;

const wrapperOnMobile = media.phone`
  margin-left: 0;
`;

const Wrapper = styled.div`
  display: flex;
  margin-left: 21px;
  margin-bottom: 4px;
  ${wrapperOnMobile};
`;

export default Wrapper;
